import Image from 'next/image';
import PropTypes from 'prop-types';

const defaultTitleClassName =
  'text-center font-Montserrat text-slate-600 font-bold items-center text-sm w-28';

const IconTitle = ({ title, href }) =>
  href ? (
    <a href={href}>
      <div className={defaultTitleClassName}>{title}</div>
    </a>
  ) : (
    <div className={defaultTitleClassName}>{title}</div>
  );

const ImageContent = ({ href, alt, url: src, className }) =>
  href ? (
    <a href={href}>
      <Image
        height={50}
        priority={true}
        width={50}
        {...{ alt, className, src }}
      />
    </a>
  ) : (
    <Image
      height={50}
      priority={true}
      width={50}
      {...{ alt, className, src }}
    />
  );

const IconMobile = (props) => (
  <div className='flex flex-col items-center justify-start shadow-xl shadow-red-100 rounded-xl w-36 h-32'>
    <div className='rounded-full xxxs:w-full mx-auto'>
      <ImageContent {...props} />
    </div>
    <IconTitle {...props} />
  </div>
);

export default IconMobile;

IconMobile.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  alignment: PropTypes.string,
  alt: PropTypes.string,
  href: PropTypes.string
};
